import pic1 from '../../assets/images/gallery/model1.JPG';
import pic2 from '../../assets/images/gallery/model2.JPG';
import pic3 from '../../assets/images/gallery/model3.JPG';
import pic5 from '../../assets/images/gallery/model5.JPG';
import pic6 from '../../assets/images/gallery/Cumi-1.jpg';
import pic7 from '../../assets/images/gallery/Cumi-2.jpg';
import pic8 from '../../assets/images/gallery/Cumi-3.jpg';
import pic9 from '../../assets/images/gallery/Cumi-4.jpg';
import pic10 from '../../assets/images/gallery/Cumi-5.jpg';
import pic11 from '../../assets/images/gallery/Cumi-6.jpg';
import pic12 from '../../assets/images/gallery/Cumi-7.jpg';
import pic13 from '../../assets/images/gallery/Cumi-8.jpg';
import pic14 from '../../assets/images/gallery/Cumi-9.jpg';
import pic15 from '../../assets/images/gallery/Cumi-10.jpg';

export const pictureData = [
  {
    image: pic1,
    subtitle: 'subtitle1',
    title: 'title1 ',
    detail: 'detail1',
  },
  {
    image: pic2,
    title: 'title2 ',
    subtitle: 'subtitle2',
    detail: 'detail21',
  },
  {
    image: pic3,
    title: 'title3 ',
    subtitle: 'subtitle3',
    detail: 'detail3',
  },
  {
    image: pic5,
    title: 'title5 ',
    subtitle: 'subtitle5',
    detail: 'detail5',
  },
  {
    image: pic6,
    title: 'title6 ',
    subtitle: 'subtitle6',
    detail: 'detail6',
  },
  {
    image: pic7,
    title: 'title7 ',
    subtitle: 'subtitle7',
    detail: 'detail7',
  },
  {
    image: pic8,
    title: 'title8 ',
    subtitle: 'subtitle8',
    detail: 'detail8',
  },
  {
    image: pic9,
    title: 'title9 ',
    subtitle: 'subtitle9',
    detail: 'detail9',
  },
  {
    image: pic10,
    title: 'title10 ',
    subtitle: 'subtitle10',
    detail: 'detail10',
  },
  {
    image: pic11,
    title: 'title11 ',
    subtitle: 'subtitle11',
    detail: 'detail11',
  },
  {
    image: pic12,
    title: 'title12 ',
    subtitle: 'subtitle12',
    detail: 'detail12',
  },
  {
    image: pic13,
    title: 'title13 ',
    subtitle: 'subtitle13',
    detail: 'detail13',
  },
  {
    image: pic14,
    title: 'title14 ',
    subtitle: 'subtitle14',
    detail: 'detai14',
  },
  {
    image: pic15,
    title: 'title15 ',
    subtitle: 'subtitle15',
    detail: 'detail15',
  },
];
